export default "__VITE_ASSET__Bfk7ftKn__"